// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, Input, OnInit, AfterViewInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import {
  AlertType,
  IAMUser,
  QueueAlertAction,
  RemoveItem,
  RemoveType,
  RoleDetail,
  RoleUserScope,
  GoAction,
  readParameterFromRouterState
} from '@app/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { State } from '@app/access-management/state';
import { DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { DeleteModalComponent, RemoveResult } from '../role-details/delete-modal/delete-modal.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-role-scope-card',
  templateUrl: './role-scope-card.component.html',
  styleUrls: ['./role-scope-card.component.scss']
})
export class RoleScopeCardComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('actionTemplate') actionTemplate: any;
  @ViewChild('dataTableAjax') dataTableAjax!: DataTableAjaxComponent;

  columns: any[] = [];

  username?: string;
  roleId?: string;

  dataTableUrl = '';
  @Input() roleDetail?: RoleDetail = undefined;
  @Input() user?: IAMUser;
  @Input() orgId = '';

  role: any;

  constructor(private modalService: NgbModal, private store: Store<State>, private activatedRoute: ActivatedRoute) {
    this.username = readParameterFromRouterState(this.activatedRoute, 'username');
  }

  ngOnInit() {
    this.role = this.roleDetail && this.roleDetail.role;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['roleDetail'] && changes['roleDetail'].currentValue) {
      this.role = this.roleDetail && this.roleDetail.role;
      if (this.dataTableAjax) {
        this.dataTableAjax.refreshTable();
      }
    }
    if (changes['user'] && changes['user'].currentValue) {
      if (this.dataTableAjax) {
        this.dataTableAjax.refreshTable();
      }
    }
  }

  ngAfterViewInit() {
    this.roleId = this.role ? this.role.id : '';
    this.username = this.user ? this.user.username : '';
    this.dataTableUrl = `/roles/${this.roleId}/users/${this.username}/scopes`;
    if (this.orgId !== '') {
      this.dataTableUrl = `/accounts/${this.orgId}/roles/${this.roleId}/users/${this.username}/scopes`;
    }
    this.columns = [
      {
        name: 'Constraints',
        prop: 'object_name',
        headerClass: 'ml-8',
        flexGrow: 2
      },
      {
        name: 'Scope',
        prop: 'object_type_name',
        flexGrow: 1
      },
      {
        name: 'Level',
        prop: 'level',
        flexGrow: 1
      },
      {
        name: 'Actions',
        cellTemplate: this.actionTemplate,
        flexGrow: 1
      }
    ];
  }

  onRemoveRow(row: any) {
    const modalRef = this.modalService.open(DeleteModalComponent, { centered: true, windowClass: 'no-border' });
    modalRef.componentInstance.removeItem = { type: RemoveType.ROLESCOPE, data: row } as RemoveItem;

    const resultPromise = modalRef.result as Promise<RemoveResult>;
    resultPromise.then(result => {
      switch (result) {
        case RemoveResult.REMOVE_SUCCEEDED: {
          this.dataTableAjax.refreshTable();
          if (this.dataTableAjax._rows.length === 1) {
            this.store.dispatch(new GoAction(['/iam/users', this.username]));
          }
          this.store.dispatch(
            new QueueAlertAction({ alertText: `User Role Scope delete succeeded.`, alertType: AlertType.SUCCESS })
          );
          break;
        }

        case RemoveResult.REMOVE_FAILED: {
          this.store.dispatch(
            new QueueAlertAction({ alertText: `User Role Scope delete failed.`, alertType: AlertType.ERROR })
          );
          break;
        }

        default: {
          break;
        }
      }
    });
  }

  trackColumns(idx: number) {
    return idx;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-scope-card/role-scope-card.component.ts